<template>
  <v-container>
    <simpleRoulette
    v-if="!this.$vuetify.breakpoint.smAndDown"
    v-bind:welcomeText = "welcomeText"
    v-bind:descText = "descText"
    v-bind:sideImg = "sideImg"
    v-bind:cards = "cards"
    ></simpleRoulette>
    <simpleRouletteMobile
    v-if="this.$vuetify.breakpoint.smAndDown"
    v-bind:welcomeText = "welcomeText"
    v-bind:descText = "descText"
    v-bind:sideImg = "sideImg"
    v-bind:cards = "cards"
    ></simpleRouletteMobile>
  </v-container>
</template>

<script>
  import simpleRoulette from '../../components/simpleRoulette';
  import simpleRouletteMobile from '../../components/simpleRouletteMobile';

    export default {
      name: 'savingRoulette',
      components: {
        simpleRoulette,
        simpleRouletteMobile,
      },
      data: () => ({
        welcomeText: "Welcome to shaving roulette!",
        descText: "In this roulette, you will be given an outfit to wear all day Saturday and Sunday, prep to do Saturday morning, and a task to complete for each day of the weekend as well as how long to perform that task.",
        sideImg: "https://i.imgur.com/aWXrLky.png",
          cards:[
            {
              rollTitle: "Outfit",
              cumulative: false,
              items: [
                {
                  text: "Little Black Dress",
                  active: false
                },
                {
                  text: "Crop Top/Short Shorts",
                  active: false
                },
                {
                  text: "Blouse/Skirt",
                  active: false
                },
                {
                  text: "Tight Tee/Tight Jeans",
                  active: false
                },
                {
                  text: "Sundress",
                  active: false
                },
              ],
              rolled: false
            },
            {
              rollTitle: "Prep",
              cumulative: true,
              items: [
                {
                  text: "Shave All Body Hair",
                  active: false
                },
                {
                  text: "Paint Nails",
                  active: false
                },
                {
                  text: "Makeup",
                  active: false
                },
                {
                  text: "Butt Plug",
                  active: false
                },
                {
                  text: "Chastity",
                  active: false
                }
              ],
              rolled: false
            },
            {
              rollTitle: "Saturday Task",
              cumulative: false,
              items: [
                {
                  text: "Blow A Dildo",
                  active: false
                },
                {
                  text: "Fuck A Dildo",
                  active: false
                },
                {
                  text: "Watch Sissy Hypno",
                  active: false
                },
                {
                  text: "All Above At Once",
                  active: false
                }
              ],
              rolled: false
            },
            {
              rollTitle: "Saturday Duration",
              cumulative: false,
              items: [
                {
                  text: "10 Minutes",
                  active: false
                },
                {
                  text: "30 Minutes",
                  active: false
                },
                {
                  text: "1 Hour",
                  active: false
                },
                {
                  text: "10 Minutes/Hour All Day",
                  active: false
                }
              ],
              rolled: false
            },
            {
              rollTitle: "Sunday Task",
              cumulative: false,
              items: [
                {
                  text: "Dance To Pop Music",
                  active: false
                },
                {
                  text: "Watch Female POV Porn",
                  active: false
                },
                {
                  text: "Browse Grindr",
                  active: false
                },
                {
                  text: "Watch Makeup Tutorials",
                  active: false
                }
              ],
              rolled: false
            },
            {
              rollTitle: "Sunday Duration",
              cumulative: false,
              items: [
                {
                  text: "10 Minutes",
                  active: false
                },
                {
                  text: "30 Minutes",
                  active: false
                },
                {
                  text: "1 Hour",
                  active: false
                },
                {
                  text: "10 Minutes/Hour All Day",
                  active: false
                }
              ],
              rolled: false
            },
          ]
        }),
        methods: {
          roll() {
            this.cards.forEach(function(card) {
              card.rolled = true;
            })
          }
        },
      }
  </script>